import { TFunction } from "i18next";

import { Text } from "@pentabd/ui";

import { StatusBadge, ViewButton } from "@components";

import { ROUTES } from "@constants/routes";

const {
  HRM: { FILE_INQUIRY },
} = ROUTES;

export const TableColumn = (t: TFunction<"translation", undefined>) => {
  return [
    {
      id: 1,
      key: "fileType",
      name: t("FILE_INQUIRY_LIST.TABLE.COLUMN.FILE_TYPE"),
      render: (fileType: String) => (
        <Text className="text-nowrap">{fileType}</Text>
      ),
    },
    {
      id: 2,
      key: "subject",
      name: t("FILE_INQUIRY_LIST.TABLE.COLUMN.SUBJECT"),
      render: (subject: String) => (
        <Text className="text-nowrap">{subject}</Text>
      ),
    },
    {
      id: 4,
      key: "fileFromDate",
      name: t("FILE_INQUIRY_LIST.TABLE.COLUMN.FILE_FROM_DATE"),
      render: (fileFromDate: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {fileFromDate}
        </Text>
      ),
    },
    {
      id: 5,
      key: "status",
      name: t("FILE_INQUIRY_LIST.TABLE.COLUMN.STATUS"),
      render: (status: string) => <StatusBadge status={status} />,
    },
    {
      id: 6,
      key: "uniqueName",
      name: t("FILE_INQUIRY_LIST.TABLE.COLUMN.UNIQUE_NAME"),
      render: (uniqueName: string) => (
        <Text className="text-nowrap">{uniqueName}</Text>
      ),
    },
    {
      id: 7,
      key: "id",
      name: "",
      render: (id: number) => <ViewButton link={`${FILE_INQUIRY}/${id}`} />,
    },
  ];
};
